import { useMemo } from "react";
import { BaseMap, DEFAULT_CENTER, FitBounds, Line, Pin } from "@/lib/mapProvider";

const pin = (label, cls = "") => ({ html: `<div class="lux-pin ${cls}"><span>${label}</span></div>`, size: [26, 26], anchor: [13, 26] });
const carIcon = {
  html: `<div class="lux-car"><svg width="16" height="16" viewBox="0 0 24 24" fill="#d4af37"><path d="M5 11l1.5-4.5A2 2 0 0 1 8.4 5h7.2a2 2 0 0 1 1.9 1.5L19 11v6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H8v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-6zm2.2-1h9.6l-1-3H8.2l-1 3zM7.5 14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm9 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/></svg></div>`,
  size: [34, 34],
  anchor: [17, 17],
};

export const customerIcon = {
  html: `<div style="display:flex;flex-direction:column;align-items:center"><div style="width:20px;height:20px;border-radius:50%;background:#d4af37;border:3px solid #0a0a0c;box-shadow:0 0 0 4px rgba(212,175,55,.35)"></div><span style="margin-top:2px;padding:1px 6px;border-radius:999px;background:#0a0a0c;color:#fde68a;font:600 10px sans-serif">Customer</span></div>`,
  size: [60, 40],
  anchor: [30, 10],
};

export const MapView = ({ pickup, stops = [], route = [], driver, customer, className = "", testId = "trip-map" }) => {
  const points = useMemo(() => {
    const pts = [pickup, ...stops].filter(Boolean).map((p) => [p.lat, p.lng]);
    if (driver) pts.push([driver.lat, driver.lng]);
    return pts;
  }, [pickup, stops, driver]);
  const fitKey = [pickup, ...stops].filter(Boolean).map((p) => `${p.lat},${p.lng}`).join("|") + (driver ? "|d" : "");

  return (
    <div data-testid={testId} className={`lux-map relative overflow-hidden rounded-2xl border border-amber-500/15 ${className}`}>
      <BaseMap center={DEFAULT_CENTER} zoom={12} className="h-full w-full" style={{ minHeight: 300 }}>
        {route.length > 1 && <Line positions={route} />}
        {pickup && <Pin position={[pickup.lat, pickup.lng]} icon={pin("P", "pickup")} />}
        {stops.filter(Boolean).map((s, i) => <Pin key={`${i}-${s.lat}`} position={[s.lat, s.lng]} icon={pin(i + 1)} />)}
        {driver && <Pin position={[driver.lat, driver.lng]} icon={carIcon} />}
        {customer && <Pin position={[customer.lat, customer.lng]} icon={customerIcon} />}
        <FitBounds points={points} fitKey={fitKey} />
      </BaseMap>
      {customer && <span data-testid={`${testId}-customer-pin`} className="sr-only">{customer.lat.toFixed(5)},{customer.lng.toFixed(5)}</span>}
      {driver && <span data-testid="driver-marker-coords" className="sr-only">{driver.lat.toFixed(5)},{driver.lng.toFixed(5)}</span>}
    </div>
  );
};
